import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';

import { QuickQuoteFeatureFacade } from '../+state/quick-quote-feature/quick-quote-feature.facade';

@Component({
  selector: 'quick-quote-container',
  templateUrl: './quick-quote-container.component.html',
  styleUrls: ['./quick-quote-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class QuickQuoteContainerComponent implements OnInit, OnDestroy {
  constructor(private quickQuoteFeatureFacade: QuickQuoteFeatureFacade) {}

  ngOnInit(): void {}

  ngOnDestroy() {
    this.quickQuoteFeatureFacade.resetQuickQuote();
  }
}
